import { render, staticRenderFns } from "./modalEasylunchEntregaDetalle.vue?vue&type=template&id=12cafb21&"
import script from "./modalEasylunchEntregaDetalle.vue?vue&type=script&lang=js&"
export * from "./modalEasylunchEntregaDetalle.vue?vue&type=script&lang=js&"
import style0 from "./modalEasylunchEntregaDetalle.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports